import { create } from 'zustand';

interface OrganizationSwitcherState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

/**
 * Store for controlling the organization switcher dialog
 * Used to open the org switcher from anywhere in the application (e.g., keyboard shortcuts, menu items)
 */
export const useOrganizationSwitcherStore = create<OrganizationSwitcherState>(
  set => ({
    isOpen: false,
    open: () => set({ isOpen: true }),
    close: () => set({ isOpen: false }),
    toggle: () => set(state => ({ isOpen: !state.isOpen })),
  }),
);

/**
 * Utility function to open the organization switcher
 * Can be called from anywhere in the application
 */
export function openOrganizationSwitcher() {
  useOrganizationSwitcherStore.getState().open();
}
